import React 		from 'react'
import classnames 	from 'classnames'
import { connect } 	from 'react-redux'
import {
	isFinite
} from 'lodash'

import ARYImage 		from '../ary-image'
import BGEl 			from '../bg-el'
import ParallaxEl		from '../parallax-el'
import SectionSpacer 	from '../section-spacer'

class SectionWrap extends React.Component {
	constructor(props) {
		super(props)
	}

	renderRule(){
		return <div className="cont"><div className="sectionWrap-rule" /></div>
	}

	renderSectionContent(isStretched){
		const {
			children,
			spaceTop,
			spaceBottom,
			showRule
		} = this.props

		return <React.Fragment>
			<SectionSpacer space={ spaceTop } />
			{ children }
			<SectionSpacer space={ spaceBottom } />
			{ showRule && !isStretched ? this.renderRule() : null }
		</React.Fragment>
	}

	renderBgEl(){
		const {
			bgEl,
			bgImage,
			bgImageContain
		} = this.props

		if(bgImage){
			const parallax = false
			const bgImageEl = <ARYImage
				contain={ bgImageContain }
				image={ bgImage } />
			return <BGEl margin={ parallax }>
				{ parallax ? <ParallaxEl
					stretch={ true }
					delaySpeed={ 0.05 }
					speed={ -0.1 }>
						{ bgImageEl }
					</ParallaxEl> : bgImageEl }
			</BGEl>
		} else if(bgEl){
			return <BGEl>
				{ bgEl }
			</BGEl>
		} else {
			return null
		}
		
	}

	render() {
		const {
			className,
			id,
			bgColour,
			stretch,
			force,
			stretchInner,
			screenSize,
			headerHeight,
			innerMult,
			style,
			showRule,
			outerChildren,
			onMouseMove
		} = this.props

		const bgEl = this.renderBgEl()
		const stretchHeight = screenSize.height - headerHeight - ((isFinite(innerMult) ? innerMult : 0) * headerHeight)
		const isStretched = force || stretch

		return <section
			id={ id }
			className={ classnames('sectionWrap', {
				'sectionWrap--center': stretch || force,
				'sectionWrap--stretchInner': stretchInner,
				[`bg--${ bgColour }`]: !!bgColour && bgColour !== 'transparent'
			}, className) }
			style={ {
				...style,
				height: force ? stretchHeight : null,
				minHeight: stretch ? stretchHeight : null
			} }
			onMouseMove={ onMouseMove ? onMouseMove : null }
			>
			<div className="sectionWrap-inner">
				{ this.renderSectionContent(isStretched) }
			</div>
			{ bgEl ? <div className="sectionWrap-bg">
				{ bgEl }
			</div> : null }
			{ outerChildren ? outerChildren : null }
			{ isStretched && showRule ? <div className="sectionWrap-bottom">
					{ this.renderRule() }
				</div> : null }
		</section>
	}
}

const mapStateToProps = (state) => {
	const {
		ui
	} = state

    return {
    	headerHeight: ui.headerHeight,
    	screenSize: ui.screenSize
    }
}

export default connect(mapStateToProps, null)(SectionWrap)